export const SOFTLINE_API_HARDWARE_MANAGEMENT_LISTE = 'v1/hardwareliste/entities';
export const SOFTLINE_API_HARDWARE_MANAGEMENT_PRODUKTE = 'v1/produkt/entities';
export const SOFTLINE_API_HARDWARE_MANAGEMENT_TYPEN = 'v1/hardwaretyp/entities';
export const SOFTLINE_API_HARDWARE_MANAGEMENT_GARANTIETYPEN = 'v1/garantietyp/entities';
export const SOFTLINE_API_HARDWARE_MANAGEMENT_BETRIEBSSYSTEME = 'v1/betriebssystem/entities';
export const SOFTLINE_API_HARDWARE_MANAGEMENT_HERSTELLER = 'v1/hersteller/entities';
export const SOFTLINE_API_HARDWARE_MANAGEMENT_SUBNETZMASKEN = 'v1/subnetzmaske/entities';
export const SOFTLINE_API_HARDWARE_MANAGEMENT_SUPPORTTYPEN = 'v1/supporttyp/entities';
export const SOFTLINE_API_HARDWARE_MANAGEMENT_COMMENTS = 'v1/hardwareliste/{{idhardware}}/comments/entities';
